<div class="flex items-center justify-between w-full h-full">
  @if (label) {
    <span
      class="flex items-center justify-center w-4 h-full text-sm font-semibold tracking-wide"
      [style.width]="(items ? (100 / items.length) : 100) + '%'"
    >
      {{ label }}
    </span>
  }

  @if (items) {
    @for (item of items; track item.id) {
      @switch (item.type) {
        @case ('divider') {
          <div class="h-full border-1 border-white/10"></div>
        }

        @default {
          <nrc-toolbar-item
            class="h-full"
            [icon]="item.iconName!"
            [label]="item.label"
            [hideLabel]="item.hideLabel"
            [tooltipText]="item.tooltipText"
            [tooltipTextTopside]="item.tooltipTextTopside"
            [contextMenu]="item.contextMenu"
            [style.width]="(100 / items.length) + '%'"
            [disabled]="item.disabled? item.disabled : false"
            [isActive]="item.isActive? item.isActive : false"
            (clickEvent)="handleClickEvent(item)"
            (contextMenuActionButtonEvent)="handleContextMenuActionButtonEvent($event)"
          />
        }
      }
    }
  }
</div>
